import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileComponent } from './profile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UserInfoComponent } from './components/user-info/user-info.component';
import { CompanyInfoComponent } from './components/company-info/company-info.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

const materialModules = [MatCardModule, MatProgressSpinnerModule, MatButtonModule, MatIconModule];

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FormsModule, NgxSkeletonLoaderModule, SharedModule, ...materialModules],
  declarations: [ProfileComponent, UserInfoComponent, CompanyInfoComponent],
  exports: [ProfileComponent],
})
export class ProfileModule {}
